/**
 * App chrome typography — semantic roles for SiteRAG, admin, and shell UI.
 * Minimum interactive size: 10px labels, 12px body (no 7–8px in UI).
 *
 * Tailwind `@utility type-*` classes in index.css mirror these constants.
 */

/** Page title — site name, report shell headline */
export const TYPE_DISPLAY =
  'type-display';

/** Tab labels, card titles, panel headers */
export const TYPE_SECTION =
  'type-section';

/** Descriptions, form help, card body */
export const TYPE_BODY =
  'type-body';

/** Address, acres, timestamps — uppercase meta */
export const TYPE_META =
  'type-meta';

/** Secondary lines — intent summaries, captions */
export const TYPE_CAPTION =
  'type-caption';

/**
 * Report launch card title — section role, but WORD-LEVEL wrapping.
 *
 * `type-section` is uppercase at 0.1em tracking; with the old `break-words`
 * (`overflow-wrap:break-word`) a long single word like "INTERCONNECTION" /
 * "ENVIRONMENTAL" would break MID-WORD ("INTERCONNE/CTION") in a narrow
 * card. The fix:
 *   - `tracking-tight` overrides the inherited 0.1em so the word is
 *     narrower and fits more often;
 *   - `break-normal` (= `overflow-wrap:normal; word-break:normal`)
 *     forbids the last-resort mid-word break that `break-words` allowed —
 *     wrapping happens only at spaces;
 *   - a 2-line clamp with ellipsis (`line-clamp-2`) truncates gracefully
 *     when a single word is still wider than the card, instead of
 *     overflowing or breaking mid-word. Callers pair this with a `title=`
 *     tooltip so the full label is still reachable.
 */
export const REPORT_CARD_TITLE_CLASS =
  `${TYPE_SECTION} text-foreground leading-snug tracking-tight break-normal line-clamp-2`;

/** Report card description — body role, full wrap. text-text-primary so the
 *  report summary reads at full contrast (black in light / white in dark),
 *  not the low-contrast muted grey. */
export const REPORT_CARD_DESCRIPTION_CLASS =
  `${TYPE_BODY} text-text-primary break-words mt-1`;

/** Report card metadata line */
export const REPORT_CARD_META_CLASS =
  `${TYPE_CAPTION} break-words`;
